(() => {
  function initWearseHeader() {
  const desktopHoverQuery = window.matchMedia('(hover: hover) and (min-width: 990px)');

  function setDetailsOpen(details, isOpen) {
    details.toggleAttribute('open', isOpen);
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(isOpen));
  }

  document.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
    const details = menu.querySelector(':scope > details');
    const summary = details?.querySelector(':scope > summary');
    if (!details || !summary) return;

    let pointerClick = false;

    summary.addEventListener('pointerdown', (event) => {
      pointerClick = event.pointerType !== 'touch';
    });

    summary.addEventListener('click', (event) => {
      if (desktopHoverQuery.matches && pointerClick) {
        event.preventDefault();
        setDetailsOpen(details, true);
      }
      pointerClick = false;
    });

    menu.addEventListener('pointerenter', () => {
      if (desktopHoverQuery.matches) setDetailsOpen(details, true);
    });

    menu.addEventListener('pointerleave', () => {
      if (desktopHoverQuery.matches && !menu.contains(document.activeElement)) {
        setDetailsOpen(details, false);
      }
    });

    menu.addEventListener('focusin', () => {
      if (desktopHoverQuery.matches) setDetailsOpen(details, true);
    });

    menu.addEventListener('focusout', (event) => {
      if (desktopHoverQuery.matches && !menu.contains(event.relatedTarget)) {
        setDetailsOpen(details, false);
      }
    });

    menu.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      setDetailsOpen(details, false);
      summary.focus();
    });
  });

  const drawerDetails = document.querySelector('#Details-menu-drawer-container');
  const drawerSummary = drawerDetails?.querySelector(':scope > summary');
  const mobileSearchModal = document.querySelector('#WearseMobileSearchModal');
  const mobileSearchInput = mobileSearchModal?.querySelector('input[type="search"]');

  function cleanupDrawerState() {
    document.body.classList.remove('wearse-menu-open', 'overflow-hidden', 'overflow-hidden-tablet', 'overflow-hidden-mobile', 'overflow-hidden-desktop');
    document.documentElement.classList.remove('overflow-hidden', 'overflow-hidden-tablet', 'overflow-hidden-mobile', 'overflow-hidden-desktop');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    if (typeof removeTrapFocus === 'function') removeTrapFocus(drawerSummary || null);
  }

  function openDrawer() {
    if (!drawerDetails) return;
    drawerDetails.classList.add('menu-opening');
    document.body.classList.add('wearse-menu-open');
    drawerSummary?.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    if (!drawerDetails) return;
    drawerDetails.classList.remove('menu-opening');
    cleanupDrawerState();
    drawerDetails.removeAttribute('open');
    drawerSummary?.setAttribute('aria-expanded', 'false');
    drawerSummary?.focus();
  }

  function closeMobileSearchModal() {
    if (!mobileSearchModal) return;
    mobileSearchModal.hidden = true;
    document.body.classList.remove('overflow-hidden');
  }

  function openMobileSearchModal() {
    if (!mobileSearchModal) return false;
    mobileSearchModal.hidden = false;
    document.body.classList.add('overflow-hidden');
    window.setTimeout(() => mobileSearchInput?.focus(), 60);
    return true;
  }

  function openSearchModal() {
    if (openMobileSearchModal()) return;

    const searchModal =
      document.querySelector('.header__icons details-modal.header__search') ||
      Array.from(document.querySelectorAll('details-modal.header__search')).find((modal) => modal.offsetParent !== null) ||
      document.querySelector('details-modal.header__search');
    const searchDetails = searchModal?.querySelector('details');
    const searchSummary = searchModal?.querySelector('summary');
    const searchPanel = searchModal?.querySelector('.search-modal');

    if (!searchModal || !searchDetails || !searchSummary) return;

    if (typeof searchModal.open === 'function') {
      searchModal.open({ target: searchSummary });
    } else {
      searchDetails.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
    }

    window.setTimeout(() => {
      searchDetails.setAttribute('open', '');
      if (searchPanel) {
        searchPanel.style.setProperty('position', 'fixed', 'important');
        searchPanel.style.setProperty('inset', '0', 'important');
        searchPanel.style.setProperty('z-index', '9999', 'important');
        searchPanel.style.setProperty('display', 'block', 'important');
        searchPanel.style.setProperty('width', '100vw', 'important');
        searchPanel.style.setProperty('min-width', '100vw', 'important');
        searchPanel.style.setProperty('height', '100dvh', 'important');
        searchPanel.style.setProperty('min-height', '100dvh', 'important');
        searchPanel.style.setProperty('visibility', 'visible', 'important');
      }
      document.body.classList.add('overflow-hidden');
      searchModal.querySelector('input[type="search"]')?.focus();
    }, 60);
  }

  drawerSummary?.addEventListener('click', () => {
    window.setTimeout(() => {
      if (drawerDetails?.hasAttribute('open')) {
        openDrawer();
      } else {
        closeDrawer();
      }
    }, 0);
  });

  drawerDetails?.addEventListener('toggle', () => {
    if (drawerDetails.open) {
      openDrawer();
    } else {
      drawerDetails.classList.remove('menu-opening');
      cleanupDrawerState();
      drawerSummary?.setAttribute('aria-expanded', 'false');
    }
  });

  document.querySelector('[data-wearse-menu-close]')?.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    closeDrawer();
  });

  document.querySelector('[data-wearse-menu-search]')?.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    closeDrawer();
    setTimeout(openSearchModal, 220);
  });

  document.querySelector('[data-wearse-menu-cart]')?.addEventListener('click', () => {
    closeDrawer();
    setTimeout(() => document.querySelector('#cart-icon-bubble')?.click(), 80);
  });

  drawerDetails?.querySelectorAll('.menu-drawer__menu a[href]').forEach((link) => {
    link.addEventListener('click', cleanupDrawerState);
  });

  mobileSearchModal?.querySelectorAll('[data-wearse-mobile-search-close]').forEach((button) => {
    button.addEventListener('click', closeMobileSearchModal);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && mobileSearchModal && !mobileSearchModal.hidden) closeMobileSearchModal();
  });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWearseHeader, { once: true });
  } else {
    initWearseHeader();
  }
})();
